export function tokenizeNumericString(name: string): (string | number)[] {
  return name.split(/(\d+)/).map(part => {
    const num = parseInt(part, 10);
    return Number.isNaN(num) ? part : num;
  });
}

export function compareAlphanumeric(a: string, b: string): number {
  const tokensA = tokenizeNumericString(a.toLocaleLowerCase());
  const tokensB = tokenizeNumericString(b.toLocaleLowerCase());
  for (let i = 0; i < Math.max(tokensA.length, tokensB.length); i++) {
    const partA = tokensA[i];
    const partB = tokensB[i];
    if (partA === undefined || partB === undefined) return partB ? -1 : 1;
    if (typeof partA === "number" && typeof partB === "number") {
      if (partA !== partB) return partA - partB;
    } else if (typeof partA === "number") {
      return -1;
    } else if (typeof partB === "number") {
      return 1;
    } else if (partA !== partB) {
      return partA.localeCompare(partB);
    }
  }
  return 0;
}
